import { useMutation } from '@tanstack/react-query'
import { orpc } from './contract'

export const useGenerationModelImportExternalModelMutation = () => {
  return useMutation(orpc.generationModel.importExternalModel.mutationOptions())
}
